import { render, staticRenderFns } from "./PremiumFeatureIntroduce.vue?vue&type=template&id=60700786&scoped=true"
import script from "./PremiumFeatureIntroduce.vue?vue&type=script&lang=ts"
export * from "./PremiumFeatureIntroduce.vue?vue&type=script&lang=ts"
import style0 from "./PremiumFeatureIntroduce.vue?vue&type=style&index=0&id=60700786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60700786",
  null
  
)

export default component.exports